<template>
    <form ref="form" @submit.prevent>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-top">
            <div class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="data.logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ data.centerName }}</span>
                    <span class="address">
                        {{ data.address }} {{ data.addressDetail }} /
                        {{ `${data.telNo1 || ''}-${data.telNo2 || ''}-${data.telNo3 || ''}` }}
                    </span>
                    <span v-if="data.centerType == 'M'" class="type">본사</span>
                    <span v-else class="type">지점</span>
                </div>
            </div>
        </div>

        <div class="com-tab">
            <span v-for="(item, index) in submenus" :key="index">
                <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                    {{ item.label }}
                </router-link>
            </span>
        </div>

        <div class="holiday-setting-content">
            <div class="left-box">
                <div class="title-area">
                    <span class="tit">휴일설정</span>
                    <span class="txt">운영시간에서 설정한 휴무일 이외의 휴일을 설정합니다.</span>
                </div>
                <div class="calendar-area">
                    <b-calendar :date-info-fn="dateClass" locale="kr" @context="changeDate"></b-calendar>
                </div>
            </div>
            <div class="right-box">
                <div class="top-area">
                    <span class="year">&lt; {{ selectedDate.getFullYear() }} &gt;</span>
                    <div class="right-btn">
                        <button
                            :class="{ white: !isEditing }"
                            class="com-btn"
                            type="button"
                            @click="isEditing = !isEditing"
                            v-html="isEditing ? '완료' : '수정'"
                        />
                        <button
                            class="com-btn"
                            type="button"
                            @click="holidays.push({ centerId, added: 1, holidayType: 'C' })"
                        >
                            + 추가
                        </button>
                    </div>
                </div>
                <table class="com-table no-border">
                    <colgroup>
                        <col style="width: 220px" />
                        <col style="width: 420px" />
                        <col style="width: 90px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>일정</th>
                            <th>내용</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <span class="location">{{ onIsShowAlert() }}</span>

                        <tr v-for="(item, index) in holidays" :key="index">
                            <td>
                                <single-calendar
                                    v-if="isEditing || item.added"
                                    :date="item.holidayDate"
                                    required
                                    @update="
                                        (v) => {
                                            onUpdateDate(item, v);
                                        }
                                    "
                                ></single-calendar>
                                <span v-else>{{ item.holidayDate }}</span>
                            </td>
                            <td class="center">
                                <input
                                    v-if="isEditing || item.added"
                                    v-model="item.content"
                                    class="w100p"
                                    required
                                    type="text"
                                />
                                <span v-else>{{ item.content }}</span>
                            </td>
                            <td>
                                <button
                                    v-if="isEditing || item.added"
                                    class="com-btn red"
                                    type="button"
                                    @click="onClickBtnDelete(item, index)"
                                >
                                    삭제
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="check-line">
                    <div class="com-check">
                        <input id="day-check" v-model="holidayCheckYn" name="day-check" type="checkbox" />
                        <label for="day-check">국가 공휴일을 휴무일로 지정합니다.</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button :disabled="isLoading" class="com-btn blue" type="button" @click="save">저장</button>
        </div>
    </form>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { Utils } from '@/assets/js/utils';

export default {
    name: 'SettingCenterHoliday',
    components: { LoadingSpinner },
    props: ['centerId'],
    computed: {},
    data() {
        return {
            isLoading: false,
            isEditing: false,
            data: {},
            holidayCheckYn: false,
            activaDateMonth: '',
            monthHolidays: [],
            holidays: [{ added: true, holidayType: 'C' }],
            deletedHolidays: [],
            selectedDate: new Date(),
            selectHolidays: [], //휴가설정 되어 있는 날짜
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterPaymentList', label: '결제내역' },
                { name: 'SettingCenterPaymentMethod', label: '결제수단' },
                { name: 'SettingCenterFitpay', label: '핏페이' }, // TESTING ON PROD
                // { name: 'SettingCenterLecture', label: '교차수강설정' },
            ],
        };
    },
    mounted() {
        this.load(this.selectedDate.getFullYear());
    },
    methods: {
        dateClass(ymd, date) {
            /*
            기존 소스
            if (this.selectHolidays.indexOf(ymd) > -1) {
                return 'active-round';
            }
            */
            /* 예시 소스: 송원섭 */
            /*
            if (ymd === "2021-03-22") {
                return 'active-round';  // 휴일 active 클래스
            }
             */
            for (let d of this.selectHolidays) {
                if (ymd === d) {
                    return 'active-round';
                }
            }
            return false;
        },
        async getMonthHolidays(ym) {
            console.log('ym', ym);
            api.get(`/admin/api/center/${this.centerId}/holiday/${ym}`)
                .then((res) => {
                    this.isLoading = false;
                    this.selectHolidays = [];
                    for (let d of res.data) {
                        this.selectHolidays.push(d.holidayDate);
                        console.log(this.selectHolidays);
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                });
        },
        changeDate(context) {
            const year = context.activeDate.getFullYear();
            if (year != this.selectedDate.getFullYear()) {
                this.selectedDate = context.activeDate;
                this.load(year);
            }

            if (!Utils.isEmpty(context.activeDate)) {
                const ym = `${context.activeDate.getFullYear()}-${(context.activeDate.getMonth() + 1)
                    .toString()
                    .padStart(2, '0')}`;
                if (ym !== this.activaDateMonth) {
                    this.activaDateMonth = ym;
                    this.getMonthHolidays(ym);
                }
            }
        },
        load(year) {
            if (!this.centerId) return;
            this.isLoading = true;

            // 스웨거 검색: 센터조회
            api.get(`/admin/api/center/${this.centerId}`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    const telNo = (this.data.telNo || '').match(/(\d{2,3})(\d{3,4})(\d{4})/);
                    if (telNo) {
                        this.data.telNo1 = telNo[1];
                        this.data.telNo2 = telNo[2];
                        this.data.telNo3 = telNo[3];
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = {};
                    console.log(res);
                    if (res.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });

            // 스웨거 검색: 년도별 센터 휴일 가져오기
            api.get(`/admin/api/center/${this.centerId}/holiday/year/${year}`)
                .then((res) => {
                    this.isLoading = false;
                    this.holidays = res.data.holidays;
                    this.holidayCheckYn = res.data.centerHolidaySetting.holidayCheckYn;
                    if (this.holidays.length == 0) {
                        this.holidays.push({ added: true, holidayType: 'C' });
                    } else {
                        console.log(this.holidays);
                        /*
                        this.data.hollidayOffAutoYn = (
                            this.holidays.filter(o => o.holidayCheckYn === true) || [{}]
                        ).pop().holidayCheckYn;
                        */
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.holidays = [];
                    console.log(res);
                    if (res.status != 404) alert(`오류가 발생했습니다.\n${res.data.message}`);
                    console.error(res);
                });
        },
        save() {
            if (!this.$refs.form.checkValidity() || this.isLoading) {
                return;
            }

            const holidays = [];
            for (let h of this.holidays) {
                const { centerHolidayCalId, holidayDate, holidayType, content } = h;
                holidays.push({
                    centerHolidayCalId,
                    holidayDate,
                    holidayType,
                    content,
                });
            }
            const { deletedHolidays, holidayCheckYn } = this;
            const data = {
                holidays,
                deletedHolidays,
                holidayCheckYn,
                year: this.selectedDate.getFullYear(),
            };

            this.isLoading = true;
            // 스웨거 검색: 센터 휴일설정
            api.post(`/admin/api/center/${this.centerId}/holiday`, data)
                .then((res) => {
                    this.isLoading = false;
                    this.isEditing = false;
                    alert('저장했습니다.');
                    this.load(this.selectedDate.getFullYear());
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.isEditing = false;
                    alert(`오류가 발생했습니다.\n${res.data.message}`);
                })
                .finally(() => {
                    this.load(this.selectedDate.getFullYear());
                });
        },
        onUpdateDate(item, dt) {
            for (let hd of this.holidays) {
                if (hd.holidayDate === dt && !this.isShowAlert) {
                    alert('이미 존재하는 휴일입니다.');
                    this.isShowAlert = true;
                    return false;
                }
            }

            item.holidayDate = dt;
        },
        onIsShowAlert() {
            this.isShowAlert = false;
        },
        onClickBtnDelete(item, index) {
            // 목록에서 제거
            this.holidays.splice(index, 1);

            const { centerHolidayCalId, holidayDate, holidayType } = item;

            if (!Utils.isEmpty(holidayDate)) {
                this.deletedHolidays.push({
                    centerHolidayCalId,
                    holidayDate,
                    holidayType,
                });
            }
        },
    },
};
</script>
<style lang="scss"></style>
